export default __webpack_public_path__ + "static/media/ic-admin-black.c4be2f1b.svg";